import axios from 'axios';
import { retornoHashValor } from '../cripotografia/hash';

const url = retornoHashValor(process.env.REACT_APP_1);
const CLIENT = process.env.REACT_APP_CLIENT_ID_PASS;
const PASS = process.env.REACT_APP_PASSWORD_ID_PASS;
const REDIRECT_URL = process.env.REACT_APP_REDIRECT_URL;

class GenerateToken {
    constructor(
        client_id = CLIENT,
        password_id = PASS,
        redirect_uri = REDIRECT_URL
    ) {
        this.api = axios.create({
            baseURL: url,
            timeout: 1000,
            headers: {
                'Content-Type': 'application/json',
                'x-auth-token': localStorage.getItem('token') 
            }
            
        });
        this.client_id = client_id;
        this.password_id = password_id;
        this.redirect_uri = redirect_uri;
        this.grant_code = '';
    }

    async grantCode() {
        try {
            const grant_code = await this.api.post(
                '/oauth/grant-code',
                {
                    client_id: this.client_id,
                    redirect_uri: this.redirect_uri
                }
            ).then(response => response.data);

            const { redirect_uri } = grant_code;
            const [, code] = redirect_uri.split('=');

            this.grant_code = code;

            const { access_token, refresh_token } = await this.accessToken();

            localStorage.setItem('access_token', access_token);
            localStorage.setItem('refresh_token', refresh_token);

            return { access_token,
                refresh_token };
        } catch (error) {
            throw Object({
                error: 'Erro Inesperado!',
                stack: error
            });
        }
    }

    async accessToken() {
        try {
            const access_token = await this.api.post(
                '/oauth/access-token',
                {
                    grant_type: 'authorization_code', //authorization_code,
                    code: this.grant_code//access_code
                },
                {
                    auth: {
                        username: this.client_id,
                        password: this.password_id
                    }
                }
            ).then(response => response.data);

            return access_token;
        } catch (error) {
            throw Object({
                error: 'Erro Inesperado',
                stack: error
            });
        }
    }

    async refreshToken(dataToken) {
        try {
            const response = await this.api.post('auth/refresh-token', { refresh_token: dataToken });
            const statusOk = 200;

            if (response.status === statusOk) {
                const { token, refresh_token } = response.data;

                localStorage.setItem('token', token);
                localStorage.setItem('refresh_token', refresh_token);

                return token;
            }
      
            throw new Error('Refresh token failed');
        } catch (error) {
            if (error.response?.status === 403 || error.response?.status === 401) {
                throw new Error('Refresh token error');
            }
        }
    }
}

export default new GenerateToken();
